import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/media';
import { formatDate } from '@/utils/media';

interface NewsCardProps {
  item: NewsItem;
  layout?: 'list' | 'grid';
}

export default function NewsCard({ item, layout = 'list' }: NewsCardProps) {
  if (layout === 'grid') {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex flex-col overflow-hidden rounded-lg border border-background-800 bg-background-900 transition-colors hover:border-primary-600"
      >
        <div className="aspect-[16/9] w-full overflow-hidden bg-background-800">
          <img
            src={item.image}
            alt={item.title}
            title={`${item.title} - 嫩草影院资讯`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-1 flex-col p-4">
          <div className="flex items-center gap-2 text-xs">
            <span className="rounded-md bg-secondary-500/20 px-2 py-0.5 font-medium text-secondary-300">
              {item.type}
            </span>
            <span className="text-foreground-500">{formatDate(item.publishTime)}</span>
          </div>
          <h3 className="mt-3 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-50 transition-colors group-hover:text-primary-400">
            {item.title}
          </h3>
          <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-400">
            {item.summary}
          </p>
          <span className="mt-3 flex items-center gap-1 text-xs font-medium text-primary-400">
            阅读全文
            <i className="ri-arrow-right-line" />
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex gap-4 border-b border-background-800 py-4 last:border-b-0"
    >
      <div className="h-[84px] w-[120px] shrink-0 overflow-hidden rounded-md bg-background-800 sm:h-[96px] sm:w-[150px]">
        <img
          src={item.image}
          alt={item.title}
          title={`${item.title} - 嫩草影院资讯`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-center gap-2 text-xs">
          <span className="rounded-md bg-secondary-500/20 px-2 py-0.5 font-medium text-secondary-300">
            {item.type}
          </span>
          <span className="text-foreground-500">{formatDate(item.publishTime)}</span>
        </div>
        <h3 className="mt-2 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-50 transition-colors group-hover:text-primary-400 sm:text-base">
          {item.title}
        </h3>
        <p className="mt-1.5 hidden line-clamp-2 text-sm leading-relaxed text-foreground-400 sm:block">
          {item.summary}
        </p>
      </div>
    </Link>
  );
}